var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-dropdown",
    {
      staticClass: "international",
      attrs: { trigger: "click" },
      on: { command: _vm.handleSetLanguage },
    },
    [
      _c("div", { staticClass: "lang-select-container" }, [
        _c("i", { staticClass: "el-icon-location-information" }),
        _c("span", { staticClass: "current-lang" }, [
          _vm._v(_vm._s(_vm.currentLanguageText)),
        ]),
      ]),
      _c(
        "el-dropdown-menu",
        { attrs: { slot: "dropdown" }, slot: "dropdown" },
        [
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "zh", command: "zh" } },
            [
              _c("span", { class: { "active-lang": _vm.language === "zh" } }, [
                _vm._v("中文"),
              ]),
            ]
          ),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "en", command: "en" } },
            [
              _c("span", { class: { "active-lang": _vm.language === "en" } }, [
                _vm._v("English"),
              ]),
            ]
          ),
          _c(
            "el-dropdown-item",
            { attrs: { disabled: _vm.language === "ko", command: "ko" } },
            [
              _c("span", { class: { "active-lang": _vm.language === "ko" } }, [
                _vm._v("한국어"),
              ]),
            ]
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }